/* tslint:disable */
const de = {
	login: 'Anmelden',
	register: 'Registrieren',
	emailAndUserName: 'E-Mail/Benutzername',
	passForgot: 'Passwort vergessen?',
	usePasswordRecovery: 'Passwort wiederherstellen',
	verificationSuccessMsg: 'Verifizierung erfolgreich',
	verificationFailedMsg: 'Hoppla! Versuchen Sie es später noch einmal',
	registration: 'Registrierung',
	registerConfirmationMessage: 'Mit der Registrierung stimmst du den',
	termsOfUse: 'AGB',
	andThe: 'und der',
	privacyPolicy: 'Datenschutzerklärung zu',
	alreadyAccount: 'Bereits registriert?',
	noAccount: 'Du hast noch kein Konto?',
	copyShareLink: 'Link kopieren und mit Freunden teilen!',
	sizeOfContest: 'Contestgröße',
	close: 'Schließen',
	copyLink: 'Link kopieren',
	pointSystem: 'Variante',
	entryFee: 'Einsatz',
	prizeStructure: 'Preisstruktur',
	multiEntry: 'Mehrfach-Teilnahme',
	multipleEntries: 'Mehrfachteilnahme',
	contestName: 'Contestname',
	visibility: 'Sichtbar',
	private: 'Privat',
	public: 'Öffentlich',
	next: 'Weiter',
	back: 'Zurück',
	confirmAndCreate: 'Bestätigen & Erstellen',
	chooseGames: 'Spiele auswählen',
	selectAllGame: 'Alle Spiele auswählen',
	chooseLeague: 'Liga wählen',
	settings: 'Einstellungen',
	contestSize: 'Contesgröße',
	chooseContestSize: 'Contestgröße auswählen',
	chooseNumberOfWinners: 'Wählen Sie die Anzahl der Gewinner',
	chooseEntryFee: 'Einsatz auswählen',
	numberOfEntries: 'Anzahl Spieler auswählen',
	beginner: 'Beginner',
	beginnerDetails: 'Neu bei Stippz? Messe dich mit Spielern mit dem gleichen Erfahrungsniveau',
	tournament: 'Turnier',
	tournaments: 'Turnier',
	tournamentDetails: 'Hohe Auszahlungen mit garantierten Preispool',
	h2h: 'Head to Head',
	h2hDetails: 'Spiele gegen einen einzelnen Gegner. Gewinner kriegt alles!',
	multipliers: 'Multiplikator',
	multipliersDetails: 'Einsatz verdoppeln oder vervielfachen',
	fiftyFiftyDetails: 'Beende in der oberen Hälfte und Gewinne',
	createContest: 'Contest Erstellen',
	Tips: 'Tipps',
	sport: 'Sport',
	league: 'Liga',
	style: 'Typ',
	mode: 'Modus',
	rules: 'Regeln',
	ruleWinnerPick:
		'Bei der Confidence-Variante entscheidest du zunächst zwischen Sieg, Niederlage oder Unentschieden und vergibst dann pro Tipp selbst zusätzlich sogenannte „Confidence-Punkte“, die du dann im Falle eines richtigen Tipps erhalten möchtest.',
	ruleMaxPoint:
		'Hier solltest du strategisch vorgehen und stets die höchste Anzahl an Confidence-Punkten den Spielen zuordnen, über deren voraussichtliches Ergebnis du dir am sichersten bist.',
	ruleOnce: 'Jede Punktzahl zwischen 1 und der maximal möglichen Punktzahl kann nur einmal vergeben werden.',
	ruleMemeber: 'Beachte: Je höher die vergebene Punktzahl, desto mehr Punkte bekommst du bei einem richtigen Tipp!',
	scoring: 'Scoring',
	highestValue: 'Höchster Wert',
	lowestValue: 'Niedrigster Wert',
	confidenceValue: 'Confidence-Punkte',
	games: 'Spiele',
	entries: 'Entries',
	winZone: 'Gewinnzone',
	rulesAndScoring: 'Regeln & Punkte',
	lobby: 'Lobby',
	inviteFriends: 'Freunde einladen',
	language: 'Sprache',
	logout: 'Abmelden',
	plays: 'Spiele',
	contests: 'Wettbewerbe',
	wins: 'Sieg',
	winRate: 'Siegrate',
	profit: 'Gewinn',
	uploadNewPhoto: 'Neues Foto hochladen',
	getVerification: 'Verfiziere dein Konto	',
	verificationMsg: 'Verifizieren Sie Ihr Konto, um Zugriff auf alle Servicefunktionen zu erhalten',
	verificate: 'Verifizieren',
	save: 'Speichern',
	changePassword: 'Passwort ändern',
	userName: 'Benutzername',
	firstName: 'Vorname',
	lastName: 'Nachname',
	country: 'Land',
	dob: 'Geburtsdatum',
	oldPassword: 'Altes Passwort',
	newPassword: 'Neues Passwort',
	confirmNewPassword: 'Neues Passwort bestätigen',
	email: 'E-Mail',
	password: 'Passwort',
	cancel: 'Abbrechen',
	inviteFriendsSubTitle: 'Lade Freunde ein und erhaltet beide',
	inviteYourFriends: 'LADE DEINE FREUNDE EIN',
	shareInvitationLink: 'Teile deinen Einladungslink, z. B. per E-Mail, WhatsApp, X oder Facebook',
	friendRegister: 'DEINE FREUNDE REGISTRIEREN Sich UND ZAHLEN EIN',
	friendRegisterAndDeposit:
		'Lade deine Freunde ein und beide erhalten 5€. Vergewissere dich, dass sie deinen Einladungslink verwenden.',
	challengeFriend: 'Fordere deine Freunde heraus',
	takePart: 'Nimm an öffentlichen oder privaten Wettbewerben teil',
	inviteFriendsNow: 'Jetzt Freunde einladen',
	contestType: 'Contest Typ',
	sportsAndLeagues: 'Sport & Ligen',
	byDate: 'Nach Datum',
	byName: 'Nach Contestnamen',
	clear: 'Löschen',
	searchContest: 'Contest suchen',
	noData: 'Keine Daten gefunden.',
	fromToToDate: 'von – bis',
	join: 'Teilnehmen',
	update: 'Aktualisieren',
	noContest: 'Du nimmst an keinen Contests teil',
	arenaNoContest: 'Momentan sind keine Contests verfügbar. ',
	createFirstContest: 'Nimm an einem Contest in der Arena teil oder erstelle deinen eigenen Contest',
	arenaCreateFirstContest:
		'Aber keine Sorge, schon bald geht es weiter. Schau einfach später noch einmal vorbei oder starte deinen eigenen Contest!',
	filterResults: 'Filter Ergebnisse',
	clearAll: 'Filter löschen',
	upcoming: 'Offen',
	live: 'Live',
	history: 'Beendet',
	myProfile: 'Menü',
	contactUs: 'Kontakt',
	faq: 'FAQ',
	howToPlay: 'Spielregeln',
	switchToGerman: 'German',
	switchToEnglish: 'Englisch',
	balance: 'Konto',
	deposit: 'Einzahlung',
	nextContestStarts: 'N\u00e4chster Contest',
	withdraw: 'Auszahlung',
	Sport: 'Sportart',
	Leagues: 'Wettbewerbe',
	Style: 'Stil',
	Modes: 'Modus',
	Details: 'Details',
	Confirm: 'Best\u00e4tigen',
	standings: 'Rangliste',
	Prizes: 'Preise',
	guaranteedPrize: 'Preispool',
	confidence: 'Confidence',
	odds: 'Risk Reward',
	Classic: 'Klassisch',
	contestants: 'Teilnehmer',
	points: 'Punkte',
	rank: 'Platz',
	prize: 'Gewinn',
	players: 'Spieler',
	entrants: 'Teilnehmer',
	termOfUse: 'AGB',
	myContests: 'Meine Contests',
	sort: 'Sortieren',
	nextContestStart: 'N\u00e4chster Contest',
	myAccount: 'Benutzerdaten',
	contactDetails: 'Kontaktdaten',
	Edit: 'Bearbeiten',
	emailNotifications: 'Mitteilungen',
	gameDayUpdates: 'Spieltag Infos',
	stippzPromotions: 'STIPPZ Promotions',
	saveChanges: 'Änderungen Speichern',
	FAILED: 'Fehlgeschlagen',
	COMPLETED: 'Erledigt',
	PENDING: 'In Bearbeitung',
	OPEN: 'Offen',
	PAYOUT: 'Auszahlung',
	Send: 'Senden',
	Contest_Cancelled_Refund: 'Erstattung',
	verificationMethod: 'Verifizierungsmethode',
	select: 'W\u00e4hlen',
	transactionHistory: 'Kontoverlauf',
	soccer: 'Fußball',
	basketball: 'Basketball',
	americanFootball: 'American Football',
	hockey: 'Eishockey',
	baseball: 'Baseball',
	full: 'Gefüllt',
	Entry: 'Entry',
	playerProtection: 'Spielerschutz',
	selfExclusion: 'Selbstausschlu\u00df',
	Unlimited: 'Unbegrenzt',
	Mo: 'Mo',
	Tu: 'Di',
	We: 'Mi',
	Th: 'Do',
	Fr: 'Fr',
	Sa: 'Sa',
	Su: 'So',
	Monday: 'Montag',
	Tuesday: 'Dienstag',
	Wednesday: 'Mittwoch',
	Thursday: 'Donnerstag',
	Friday: 'Freitag',
	Saturday: 'Samstag',
	Sunday: 'Sonntag',
	instantBankTransfer: 'Sofortüberweisung',
	bankTransfer: 'Banküberweisung',
	imprint: 'Impressum',
	address: 'Adresse',
	countryOfBirth: 'Geburtsland',
	postCode: 'PLZ',
	ruleRemember: 'Beachte: Je höher die gewählte Punktzahl, desto mehr Punkte bekommst du bei einem richtigen Tipp!',
	notRegister: 'Nicht registriert?',
	termsText:
		'Mit deiner Registrierung bestätigst du, dass du ein Konto bei der Klutch Perform GmbH auf eigenen Namen und eigene Rechnung eröffnen möchtest. Zudem bestätigst du, mindestens 18 Jahre alt zu sein. Die Registrierung eines Kontos ermöglicht die Nutzung von verschiedenen angebotenen Services und unterliegt den Allgemeinen Geschäftsbedingungen (AGB). Alle von dir zur Verfügung gestellten personenbezogenen Daten werden gemäß unseren Datenschutzrichtlinien verarbeitet.',
	statusInfo: 'Contest startet, sobald 70% des Contests gefüllt ist. Jede weitere Teilnahme erhöht den Preispool',
	prizePool: 'Gewinnsumme, die komplett an die Teilnehmer ausgeschüttet wird.',
	entryFeeInfo: ' Teilnahmegebühr, die von deinem Stippz-Guthaben abgezogen wird',
	multiEntryInfo:
		'Anzahl deiner möglichen Teilnahmen an einem Contest. Mehrfach-Teilnahmen sind abhängig von der Contestgröße.',
	statusText: 'Statusbalken',
	minimumAmount: 'Mindestbetrag:10,00',
	myWinnings: 'Preise',
	Required: 'Erforderlich',
	requiredFieldValidation: '{{field}} ist erforderlich',
	countryR: 'Land',
	date: 'Geburtsdatum',
	passwordValidation:
		'Das Passwort muss mindestens 8 Zeichen enthalten, einschließlich 1 Zahl, 1 Groß- und 1 Kleinbuchstaben sowie 1 Sonderzeichen.',
	minValueValidation: '{{field}} muss größer oder gleich {{value}} sein!',
	maxValueValidation: '{{field}} muss kleiner oder gleich {{value}} sein!',
	noSpaceValidation: 'Keine Leerzeichen erlaubt',
	onlyNumbersValidation: 'Nur Zahlen erlaubt',
	onlyNumbersWithNotAllowedZeroAtFirstPosition: 'Mindestbetrag beträgt 5 Euro',
	manualDeposit:
		'Einzahlung auf dein STIPPZ-Konto per Banküberweisung. Bitte zahle unter Verwendung der unten genannten Informationen mindestens 5,00€ ein. Deine Einzahlung ist in der Regel in ein bis zwei Werktagen in deinem STIPPZ-Konto sichtbar.',
	topUp: 'Einzahlung',
	recipient: 'Empfänger',
	paymentPurpose: 'Verwendungszweck',
	none: 'LEER',
	privacy: 'Datenschutz',
	savedBank: 'Gespeicherte Bankkonten',
	addNew: 'Neue Daten',
	noSavedAccount: 'Keine gespeicherten Bankkonten',
	'Enter amount': 'Betrag eingeben',
	lobbyDate: 'Datum',
	lobbyPrize: ' Preis',
	'we sent an email verification at registration time, please check your mail and click on verification link.':
		'Wir haben dir eine Registrierungsbestätigung per E-Mail gesendet. Bitte folge den Anweisungen in unserer E-Mail, um deine Registrierung abzuschließen.',
	processingTime: 'Bearbeitungszeit: Sofort',
	Message: 'Nachricht',
	verificationSuccess:
		'Du musst dein Konto verifizieren bevor du dir Geld auszahlen kannst. Gehe zur Konto-Verifizierung',
	contactUsSubmit: 'Nachricht erfolgreich gesendet',
	oldPasswordMatch: 'Passwörter stimmen nicht überein',
	confirmPassword: 'Passwort bestätigen',
	Submit: 'Absenden',
	payOutFee: 'Auszahlgebühr: 2,50€',
	minimumAmount5: 'Mindestbetrag ist 10,00€',
	declined:
		'Deine Verifizierung ist leider fehlgeschlagen. Wir benötigen weitere Informationen. Bitte kontaktiere support@stippz.com',
	'Verification is in process and will take 2 to 3 minutes. Payout is available once verification is finished':
		'Deine Daten werden abschließend geprüft. Dieser Prozess dauert nur wenige Minuten. Du kannst dein STIPPZ-Konto vollumfänglich nutzen, sobald die Verifizierung abgeschlossen ist.',
	needsReview: ' Wir benötigen weitere Informationen. Bitte kontaktiere support@stippz.com',
	confirm: 'Bestätigen',
	publicContest: 'Öffentlich',
	privateContest: 'Privat',
	setting: 'Einstellungen',
	newEntry: 'Neue Tipps abgeben',
	existingEntry: 'Weiter mit gleichen Tipps',
	forFee: 'KOSTENLOS',
	notEnoughMatches:
		'Für diese Liga sind nicht genügend Spiele verfügbar. Bitte gehe zurück und wähle Mixed Liga. Du hast die Möglichkeit immer Montags und Donnerstags Contests für den kommenden Spieltag zu erstellen.',
	withdrawLimit: 'Dein gewünschter Auszahlbetrag übersteigt dein aktuelles Guthaben!',
	minimumUserNameValidation: 'Benutzername muss mindestens 5 Zeichen enthalten',
	verificationDone: 'Konto wurde erfolgreich registriert',
	verificationFailed: 'Hoppla! versuche es nach einiger Zeit noch einmal',
	winnerTakesItAll: 'Gewinner kriegt alles',
	top2Win: 'Top 2 gewinnen',
	top3Win: 'Top 3 gewinnen',
	top5Win: 'Top 5 gewinnen',
	top10Win: 'Top 10 gewinnen',
	top15Win: 'Top 15 gewinnen',
	top20Win: 'Top 20 gewinnen',
	top25Win: 'Top 25 gewinnen',
	top30Win: 'Top 30 gewinnen',
	top40Win: 'Top 40 gewinnen',
	top50Win: 'Top 50 gewinnen',
	top60Win: 'Top 60 gewinnen',
	top75Win: 'Top 75 gewinnen',
	top100Win: 'Top 100 gewinnen',
	top150Win: 'Top 150 gewinnen',
	top200Win: 'Top 200 gewinnen',
	top300Win: 'Top 300 gewinnen',
	top400Win: 'Top 400 gewinnen',
	top800Win: 'Top 800 gewinnen',
	top1200Win: 'Top 1200 gewinnen',
	top1600Win: 'Top 1600 gewinnen',
	top2000Win: 'Top 2000 gewinnen',
	top2500Win: 'Top 2500 gewinnen',
	top3000Win: 'Top 3000 gewinnen',
	top3300Win: 'Top 3300 gewinnen',
	top4000Win: 'Top 4000 gewinnen',
	top5000Win: 'Top 5000 gewinnen',
	top6000Win: 'Top 6000 gewinnen',
	returnLogin: 'Zurück zum Login',
	makeYourPicks: 'Gib deine Tipps ab',
	chooseConfidencePoints: 'Wähle deine Confidence Punkte	',
	pts: 'Punkte',
	place: 'Platz',
	guaranteed: 'Garantiert',
	invitationCompetition: 'Einladung zum Contest',
	competitionName: 'Contestname',
	finished: 'Abpfiff',
	myPrize: 'Mein Preis',
	copied: 'Kopiert',
	prizePoolTitle: 'Preispool',
	free: 'Frei',
	position: 'Position',
	copyClipboard: 'Link in die Zwischenablage kopiert',
	failCopy: 'Link konnte nicht kopiert werden',
	pleaseWait: 'Bitte warten...',
	liveRank: 'Live Rang',
	livePrize: 'Live-Preis',
	yourBalance: 'Dein Kontostand',
	amount: 'Betrag',
	id: 'ID',
	iBan: 'IBAN',
	sendEmail: 'Sende eine Email an',
	emailDetails:
		'mit einem Screenshot deiner Online-Überweisung oder einem Scan deines Überweisungsbelegs und dein Guthaben wird sofort aufgeladen. Teile uns bitte für eine eindeutige Zuordnung deinen Benutzernamen im Betreff mit!',
	done: 'Erledigt',
	inProgress: 'In Bearbeitung',
	passWordMustMatch: 'Die Passwörter müssen übereinstimmen',
	lowercaseValidation: '{{field}} muss eine Kleinbuchstabenzeichenfolge sein!',
	trimValidation: '{{field}} darf am Anfang/Ende keine Leerzeichen enthalten!',
	customEmailValidation: 'Bitte gib eine gültige E-Mail-Adresse an',
	customPasswordMessageValidation:
		'Das Passwort muss 1 Kleinbuchstaben, 1 Großbuchstaben, 1 Sonderzeichen und 1 Zahl enthalten und die Mindestlänge sollte 8 betragen!',
	minLengthValidation: '{{field}} muss länger sein als {{length}} Figuren!',
	maxLengthValidation: '{{field}} muss kürzer sein als {{length}} Figuren!',
	ownerName: 'Kontoinhaber',
	bankName: 'Bank Name',
	finishedGames: 'Beendete Spiele',
	yourPicks: 'Deine Tipps',
	noGames: 'In dieser Liga sind derzeit keine Spiele verfügbar.',
	started: 'Gestartet',
	youCanCreateFirstContest: 'Erstelle deinen ersten Contest',
	arena: 'Arena',
	joined: 'Anpfiff',
	guaranteedPrizepool: 'Garantierter Preispool',
	prizeMoney: 'Preisgeld',
	fiftyFifty: '50/50s',
	chooseMode: 'Variante',
	chooseType: 'Modus',
	allSports: 'Alle Sportarten',
	passwordRecoveryMessage: 'Wir senden dir einen Link zur Wiederherstellung Deines Passworts',
	passwordRecovery: 'Passwort-Wiederherstellung',
	checkEmail: 'E-Mail überprüfen',
	sendRecoveryLinkMessage: 'Wir haben dir einen Wiederherstellungslink gesendet an',
	enterNewPassword: 'Neues Passwort eingeben',
	sendRecoveryLink: 'Link senden',
	welcomeBonus: 'Willkommensbonus',
	referenceBonus: 'Referenzbonus',
	referralBonus: 'Empfehlungsbonus',
	depositFail: 'Einzahlung fehlgeschlagen',
	payout: 'Auszahlung',
	contestJoinCharge: 'verbinden',
	contestCancelledRefund: 'Erstattung',
	contestWinAmount: 'Gewinn',
	contestCommissionBooked: 'Wettbewerbskommission gebucht',
	profileUpdateMsg: 'Profil erfolgreich aktualisiert',
	draw: 'Remis',
	chooseSport: 'Sportart auswählen',
	signUpEmailMsg:
		'Der Registrierungsprozess wurde erfolgreich abgeschlossen. Wir haben dir eine E-Mail mit einem Link zur Kontoaktivierung gesendet. Bitte klicke auf den Link, um dein Konto zu aktivieren.',
	joiningMsg: 'Danke für Ihre Teilnahme!',
	wlsignUpEmailMsg: 'Deine Registrierung war erfolgreich. Du kannst dich jetzt einloggen und loslegen!',
	halfTime: 'Halbzeit',
	fullTime: 'Beendet',
	ibanValidation: 'IBAN-Format (22-stellig): DE + 20 Ziffern.',
	amountValidation: '	Bitte gib eine gültige Nummer ein',
	error404: 'Fehler 404',
	message404:
		'Leider konnte die von dir angeforderte Seite nicht gefunden werden. Möglicherweise wurde es verschoben oder gelöscht. Bitte überprüfen die URL und versuche es erneut.',
	homeButtonText: 'Gehen zur Startseite',
	error503: 'Fehler 503',
	message503:
		'Es tut uns leid, aber der Server ist derzeit nicht verfügbar und nicht bereit, die Anfrage zu bearbeiten. Bitte versuche es später noch einmal.',
	contestSearchErrorMsg: 'Der Name des Wettbewerbs muss mindestens 3 Zeichen lang sein',
	withDrawNote: 'Du kannst dir nur den gesamten Betrag auszahlen lassen. Teilauszahlungen sind nicht möglich!',
	contest1: '"Wir dürfen jetzt',
	contest1_1: 'nur nicht den Sand',
	contest1_2: 'Sand in den Kopf stecken."',
	contest1_writer: 'Lothar Matthäus',
	contest2: '"Es gibt nur eine Möglichkeit:',
	contest2_1: 'Sieg, Unentschieden',
	contest2_2: 'oder Niederlage."',
	contest2_writer: 'Franz Beckenbauer',
	contest3: '"Ein Fußballspiel',
	contest3_1: 'dauert 90 Minuten.',
	contest3_2: 'Alles andere ist Theorie."',
	contest3_writer: 'Sepp Herberger',
	contest4: '„Der Ball ist rund,',
	contest4_1: 'und ein Spiel',
	contest4_2: 'dauert 90 Minuten.“',
	contest4_writer: 'Sepp Herberger',
	contest5: '"Fußball ist wie Schach,',
	contest5_1: 'nur ohne Würfel."',
	contest5_writer: 'Lukas Podolski',
	contest7_1: 'Bundesliga Contest',
	contest7_2: '350€ Preispool',
	contest7_3: 'Teilnahme bis 14.04.2024',
	contest7_4: '150 Spieler',
	contest8: 'Täglich',
	contest8_1: 'neue Contests',
	contest9: 'Wir lieben Sport,',
	contest9_1: ' wir lieben das Spiel!',
	contest10: 'Mitspielen ist',
	contest10_1: 'der wahre Kick!',
	contest11: 'Sei Teil des Spiels',
	contest12: 'Es ist nicht nur ein Spiel, es ist ein Contest',
	contest12_1: 'es ist ein Contest',
	contest13: 'STIPPZ bringt',
	contest13_1: 'dein Fußball Erlebnis',
	contest13_2: 'auf das nächste Level',
	joinedStatusTag: 'Bin dabei',
	cancelled: 'Abgesagt',
	filters: 'Filter',
	filter: 'Anwenden',
	walletHistory: 'Historie',
	registrationPolicy: 'und bestätigst, dass du mindestens 18 Jahre alt bist.',
	of: 'von',
	seireATitle_1: 'Lebe jedes',
	seireATitle_2: 'Wochenende',
	seireATitle_3: 'italienische Emotionen',
	serieASubTitle_1: 'Sichere dir tolle Cashpreise -',
	serieASubTitle_2: 'jetzt kostenlos mitmachen!',
	bundesLigaTitle_1: 'Pure Spannung',
	bundesLigaTitle_2: 'in den Bundesliga',
	bundesLigaTitle_3: 'Contests',
	bundesLigaSubTitle_1: 'Jedes Wochenende',
	bundesLigaSubTitle_2: 'Geld-Gewinne!',
	laLigaTitle_1: 'Erlebe das Temperament',
	laLigaTitle_2: 'der La Liga an',
	laLigaTitle_3: 'jedem Wochenende',
	laLigaSubTitle_1: 'Kostenlos an Contests teilnehmen',
	laLigaSubTitle_2: 'und Preisgeld ergattern!',
	mixedTitle_1: 'Jedes Wochenende',
	mixedTitle_2: 'Europäischer Spitzen',
	mixedTitle_3: 'Fußball mit Cashpreisen',
	mixedSubTitle_1: 'Mitspielen macht',
	mixedSubTitle_2: 'richtig Bock!',
	premierTitle_1: 'Spüre die Aufregung',
	premierTitle_2: 'der Premier League',
	premierTitle_3: 'Contests',
	premierSubTitle_1: 'Jetzt mitspielen und Preisgeld',
	premierSubTitle_2: 'gewinnen - jedes Wochenende!',
	week: 'Spieltag',
	iOSInstall: 'Füge stippz deinem Home-Bildschirm hinzu, um die Web-App-Ansicht zu nutzen.',
	verificationMessage: 'Du kannst direkt nach deiner Registrierung kostenlos teilnehmen und mitspielen!',
	continue: 'Fortfahren',
	uefaEuropeanTitle_1: 'Tippe auf die Besten',
	uefaEuropeanTitle_2: 'der Besten und',
	uefaEuropeanSubTitle_1: 'räum’ ab in den Champions League Contests.',
	uefaEuropeanSubTitle_2: 'Kostenlos mitspielen und absahnen.',
	statistics: 'Statistiken',
	discord: 'Discord',
	minContestantRequired: 'Contest startet, sobald mindestens {minContestantRequired} Spieler angemeldet sind!',
	boostInfo: 'mit 2 oder mehr Toren Differenz',
	win: 'Sieg',
	winsOrDraw: 'oder Unentschieden',
	winsWith: 'mit mindestens',
	goals: 'Ziele',
	rewards: 'Meine Preise',
	withDrawHistory: 'Auszahlung Historie',
	winsBy: 'mit mindestens',
	goalsDifference: 'Toren Differenz',
	winsOrLosesByMax: 'gewinnt oder verliert mit maximal',
	pointDifference: 'Punkten Differenz',
	news: 'NEWS',
	fanshop: 'FANSHOP',
	tickets: 'TICKETS',
	riskRewardMode: 'Risk Reward Variante',
	inRiskReward: 'Bei der Variante „Risk Reward“ triffst du Entscheidungen zwischen fünf möglichen Tipps:',
	boostHomeWinDrawAwayWin: 'Boost, Heimsieg, Unentschieden, Auswärtssieg',
	boostHomeWinAwayWin: 'Boost, Heimsieg, Auswärtssieg',
	and: 'und',
	pointsRule:
		'Für jeden korrekten Tipp sammelst du Punkte, die je nach Auswahl unterschiedlich hoch ausfallen. Deine Gesamtpunktzahl entscheidet am Ende über deine Platzierung im jeweiligen Contest.',
	boost: 'Boost',
	safety: 'Safety',
	boostRule: '🚀 kann nur auf den Favoriten einer Begegnung gesetzt werden.',
	footBallBoostRule: 'Der Favorit muss mit mindestens zwei Toren Unterschied gewinnen.',
	basketBallBoostRule:
		'Der Favorit muss mit einer vorgegebenen Punktedifferenz gewinnen (je nach Begegnung zwischen 2 und 12 Punkten).',
	safetyRule: '🛡️ steht nur für den Außenseiter zur Verfügung.',
	footBallSafetyRule: 'Der Außenseiter muss gewinnen oder ein Unentschieden erreichen.',
	basketBallSafetyRule:
		'Der Außenseiter muss gewinnen oder mit maximal der vorgegebenen Punktedifferenz verlieren (je nach Begegnung zwischen 1 und 11 Punkten).',
	note: 'Hinweis',
	pointsPublication:
		'Die Punkte für die Spielpaarungen werden in der Regel spätestens 1 bis 2 Tage vor dem Start des Contests veröffentlicht. Es kann jedoch gelegentlich zu Verzögerungen kommen. In diesem Fall bleiben die entsprechenden Paarungen bis zur Veröffentlichung der Punkte gesperrt und können nicht getippt werden. Um sicherzugehen, solltest du spätestens einen Tag vor dem Start des Contests deine Tipps überprüfen und fehlende Einträge ergänzen.',
	savePicksReminder:
		'Du kannst deine Tipps jederzeit zwischenspeichern und zu einem späteren Zeitpunkt mit deinen Tipps weitermachen.',
	rulesForBoostAndSafety: 'Regeln für Boost und Safety',
	strategicAdjust:
		'Du kannst auch hier deine Tipps für noch offene Spiele strategisch anpassen, um dir in letzter Sekunde einen Vorteil zu verschaffen – entweder deinen Vorsprung auszubauen oder andere Spieler zu überholen.',
	picksChangeInfo:
		'Tipps können jeweils bis 1 Minute vor Beginn einer Partie angepasst werden. Sobald eine Partie angepfiffen wurde, ist eine Änderung nicht mehr möglich.',
	planBets:
		'Plane deine Tipps clever und nutze die besonderen Regeln für Boost und Safety, um in den Contests die Nase vorn zu haben!',
	tieRules: 'Bei Gleichstand',
	tieRulesDescription:
		'Erreichen zwei oder mehr Teilnehmer bei einem Sachpreis-Contest die gleiche Punktzahl, entscheidet der Zeitstempel der Teilnahme über den Gewinner. Dabei erhält derjenige den Vorzug, der zuerst auf "Teilnehmen" geklickt hat. Die Messung erfolgt dabei präzise bis auf die Millisekunde.',
	contestResultMessage:
		'Schade, bislang hat es nicht für die Gewinnzone gereicht. Aber keine Sorge, beim nächsten Contest hast du die Chance, es erneut zu versuchen.',
	contestWinZoneResultMessage:
		'Schade, diesmal hat es nicht für die Gewinnzone gereicht. Aber keine Sorge, beim nächsten Contest hast du die Chance, es erneut zu versuchen.',
	tipOff: 'Tip-Off',
	whiteLabelIOSInstall: 'Füge EBO deinem Home-Bildschirm hinzu, um die Web-App-Ansicht zu nutzen.',
	oddsNotAvailable: 'Punkte sind in Kürze sichtbar. Prüfe später noch einmal.',
	wlNoContest: 'Momentan sind keine Contests verfügbar.',
	wlJoinContest: 'Aber keine Sorge, schon bald geht es weiter. Schau einfach später noch einmal vorbei!',
	sideBarWins: 'Siege',
	gotIt: 'Verstanden',
	contestFull: 'Der Wettbewerb ist ausgebucht.',
	joinAnotherContest: 'Bitte versuchen Sie, an einem anderen Wettbewerb teilzunehmen!',
	goToHome: 'geh nach Hause',
	viewUpdates: 'Updates anzeigen',
	versionUpgrade: 'Neues Versions-Upgrade',
	updateAvailableMsg: 'Neue Updates verfügbar!',
	refreshMsg: 'Klicken Sie auf die Schaltfläche unten, um die neuesten Änderungen zu sehen.'
};

export default de;
